module.exports = __webpack_public_path__ + "static/img/zd09.7d6ccbd2.svg";